var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:_vm.ref,style:(_vm.buttonStyle),on:{"click":_vm.btnClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }